export class MonitoringResultData {
    parent = "";

    label = "";
    value = 0 ;
}
